<template lang='pug'>
  .feature-details
    website-spacing.whitespace
      v-row(justify='center').mb-10.mt-10
        .display-1.pa-4.grey--text.text--darken-2.text-center Bionic Metrics provides the Software QA Testing Tools so you can focus on writing tests.
      v-row(align='center' :class="{'text-center': isMobile}").whitespace
        v-col(cols='12' md='1')
          div(:class="{'text-right': !isMobile}")
            v-icon(size='50' color='cyan darken-4') web
        v-col(cols='12' md='5')
          div.feature-text
            .headline.font-weight-light.grey--text.text--darken-2 Browser Testing
            .font-weight-light.grey--text.text--darken-2 Using Selenium Webdriver, Interact with your application just like a user. Interact with forms, upload images, drag and drop, etc.
            br
            .font-weight-light.grey--text.text--darken-2 Use Macros to write tests quickly and benefit from automatic retries automatic waiting and implicit assertions
        v-col(align='center' cols='12' md='6')
          v-img(src='https://assets.bionicmetrics.com/bionic/browserTestingCode.png' :class='{"image-right": !isMobile, "elevation-4": isMobile}')
      v-row(align='center' :class="{'text-center': isMobile}").whitespace
        v-col(cols='12' md='1')
          div(:class="{'text-right': !isMobile}")
            v-icon(size='50' color='cyan darken-4') code
          //font-awesome-icon(icon='window-restore' size='6x')
        v-col(cols='12' md='5')
          div.feature-text
            .headline.font-weight-light.grey--text.text--darken-2 API Testing
            .font-weight-light.grey--text.text--darken-2 If Postman can do it, so we can we. And we can intermix API and Browser testing for powerful combinations.
            br
            .font-weight-light.grey--text.text--darken-2 Test any API endpoint, use any authentication method, assert schemas, and much more.
        v-col(align='center' cols='12' md='6')
          v-img(src='https://assets.bionicmetrics.com/bionic/api.png' :class='{"image-right": !isMobile, "elevation-4": isMobile}')
      v-row(align='center' :class="{'text-center': isMobile}").whitespace
        v-col(cols='12' md='1')
          div(:class="{'text-right': !isMobile}")
            v-icon(size='50' color='cyan darken-4') email
          //font-awesome-icon(icon='window-restore' size='6x')
        v-col(cols='12' md='5')
          div.feature-text
            .headline.font-weight-light.grey--text.text--darken-2 Validate Emails
            .font-weight-light.grey--text.text--darken-2 Easily receive emails with simple commands without all the hassle of building and maintaining your own infrastructure.
            br
            .font-weight-light.grey--text.text--darken-2 Powerfully test things like user signups with email validation or password reset with a few simple lines of code.
        v-col(align='center' cols='12' md='6')
          v-img(src='https://assets.bionicmetrics.com/bionic/emailCode.png' :class='{"image-right": !isMobile, "elevation-4": isMobile}')
      v-row(align='center' :class="{'text-center': isMobile}").whitespace
        v-col(cols='12' md='1')
          div(:class="{'text-right': !isMobile}")
            font-awesome-icon(icon='file-pdf' size='3x' color='#006064')
        v-col(cols='12' md='5')
          div.feature-text
            .headline.font-weight-light.grey--text.text--darken-2 Validate PDFs
            .font-weight-light.grey--text.text--darken-2 Easily validate PDFs and catch problems before they impact your customers.
            br
            .font-weight-light.grey--text.text--darken-2 Validate invoices, reports, etc. Make sure no customer gets a blank PDF again.
        v-col(align='center' cols='12' md='6')
          v-img(src='https://assets.bionicmetrics.com/bionic/pdfCode.png' :class='{"image-right": !isMobile, "elevation-4": isMobile}')
    website-spacing.whitespace
      v-row(justify='center')
        //.headline.pa-4.grey--text.text--darken-2.text-center These are just a handful of the powerful things the Bionic Metrics platform can do. Other things we can do include Browser Extension Testing, Data-Driven Testing, CSVs, Screenshot Comparisons, and more.
        // br
        .headline.pa-4.grey--text.text--darken-2.text-center
          a(@click='goToTrial') Request a Demo
          | &nbsp;to learn more about what Bionic Metrics can do.

</template>

<script>
import BottomArch from './BottomArch';
import WebsiteSpacing from './WebsiteSpacing';

export default {
  name: 'FeatureDetails',
  components: {BottomArch, WebsiteSpacing},
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mdAndDown;
    }
  },
  methods: {
    goToTrial() {
      this.$vuetify.goTo('#requestTrialSection');
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .feature-details {
    background: linear-gradient(180deg, #ECEFF1, #ffffff);
    min-height: 100vh;
  }

  .image-max {
    max-width: 60vmin;
  }

  .image-right {
    border-radius: 10px;
    position: relative;
    width: 30em;
    /*height: vw;*/
    transform: rotate3d(.5, -.866, 0, 15deg) rotateZ(1deg);
    box-shadow: 27.1px 62.5px 125px -25px rgba(50, 50, 93, .5), 16.2px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .image-left {
    border-radius: 10px;
    width: 30em;
    /*height: 40vw;*/
    position: relative;
    transform: rotate3d(.5, .866, 0, 15deg) rotateZ(-1deg);
    box-shadow: -27.1px 62.5px 125px -25px rgba(50, 50, 93, .5), -16.2px 37.5px 75px -37.5px rgba(0, 0, 0, .6);
    border-radius: 10px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
  }

  .feature-text {
    margin: auto;
    max-width: 30em;
  }

  .whitespace {
    margin-top: 10vh;
    margin-bottom: 10vh;
  }

  .details {
    background: #1DE9B6;
  }
</style>
